import { Button, Text, Column, Row, Grid, Checkbox } from '../../Blocks'
import OrderSummary from '../OrderSummary'
import { closePopups } from '../../../utilities'
import PlaceOrderButton from '../PlaceOrderButton'
import { useSnapshot } from 'valtio'
import { state } from '../../../context/store'

const ModalOrderSummary = () => {

  const snap = useSnapshot(state.current)

  const toggleCheck = () => {

    state.current.status.termsChecked = !state.current.status.termsChecked
    // console.log("!!! Terms 1 Toggle !!!")
  }
  const toggleCheck2 = () => {
    state.current.status.terms2Checked = !state.current.status.terms2Checked
    // console.log("!!! Terms 2 Toggle !!!")
  }

  const AcceptTerms = () => (
    <Grid cols="25px 1fr">
      <Checkbox type="checkbox" checked={snap.status.termsChecked} handleClick={toggleCheck} />

      <Text size="12px" align="left">
        I’ve confirmed I selected the correct make, model, and year for my seat.
      </Text>


      <Checkbox type="checkbox" checked={snap.status.terms2Checked} handleClick={toggleCheck2} />

      <Text size="12px" align="left">
        I confirm that my choices for Side, Top, Ribs, Logos, and any add-ons are
        correct and understand that this custom seat cover is non-refundable.
      </Text>
    </Grid>
  )



  // console.log("ORDER SUMMARY MODAL")
  return (
    <Column>
      <h2>Order Summary</h2>
      {/* <Text size="18px" weight='500' width="20ch">{snap.choices.foam.selected.mode === 'foam' ? 'Custom Seat Cover with Foam Included' : 'Custom Seat Cover Only (No Foam)'}</Text> */}
      <OrderSummary />
      <AcceptTerms />
      <Row justify="center">
        <Button handleClick={(e) => closePopups(e)}>Go back</Button>

        <PlaceOrderButton disabled={!state.current.status.termsChecked | !state.current.status.terms2Checked} />
      </Row>
    </Column>
  )
}

export default ModalOrderSummary



